import { useEffect, useState } from "react";
import PageContainer from "../components/admin/PageContainer";
import CollapseCard from "../components/admin/CollapseCard";
import Modal from "../components/admin/Modal";
import CategoryForm from "../components/admin/CategoryForm";
import CategoryList from "../components/admin/CategoryList";
import Main from "../components/admin/Main";
import { fetchCategory, createCategory, updateCategory, deleteCategory } from "../service/CategoryService";
import { useToast } from "../components/toast/ToastProvider";

const CategoryPage = () => {
  const [showModal, setShowModal] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const toast = useToast()
  const fetchData = async () => {
    try {
      const res = await fetchCategory();
      setCategoryData(res);
    } catch (error) {
      toast("Error in fetching", "ERROR");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  
  const handleSaveCategory = async (formData) => {
    const { id, code, name, imageUrl, file } = formData;
    const formDataObj = new FormData();
    formDataObj.append("code", code);
    formDataObj.append("name", name);

    if (id) {
      formDataObj.append("id", id);
    }

    if (file) {
      formDataObj.append("imageUrl", file);
    } else if (imageUrl) {
      formDataObj.append("imageUrl", imageUrl);
    }

    if (id) {
      const res = await updateCategory(id, formDataObj);
      if (res) {
        toast("Category updated sucessfully");
      }

      setShowModal(false);
      fetchData();
      setSelectedCategory(null);
    } else {
      const res = await createCategory(formDataObj);
      fetchData();
      toast("Category added sucessfully");
      setShowModal(false);
    }
  };

const handleDelete = async (id) => {
  const confirmed = window.confirm("Are you sure you want to delete this category?");
  if (!confirmed) return;

  try {
    await deleteCategory(id);
    fetchData();
    toast('Category deleted successfully');
  } catch (error) {
    toast.error('Failed to delete category');
    console.error(error);
  }
};


  const handleEdit = (category) => {
    setSelectedCategory(category);
    setShowModal(true);
  };

  return (
    <Main>
      <PageContainer
        title="Category Page"
        buttonText="ADD"
        onButtonClick={() => {
          setSelectedCategory(null);
          setShowModal(true);
        }}
      >

        <Modal
          visible={showModal}
          size="lg"
          onClose={() => {
            setShowModal(false);
            setSelectedCategory(null);
          }}
          headerText={selectedCategory ? "Edit Category" : "Add Category"}
          centered
        >
          <CategoryForm
            initialValues={selectedCategory}
            onSubmit={handleSaveCategory}
            onCancel={() => {
              setShowModal(false);
              setSelectedCategory(null);
            }}
          />
        </Modal>


        <CollapseCard title="Category List">
          <CategoryList
            categoryData={categoryData}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default CategoryPage;